import Vue from 'vue'
import App from './App.vue'
import './assets/css/index.css'
import global from './global'
import Throttle from './abstComponents/throttle'
import Tab from './components/public/Tab.vue'
import Popup from './components/public/Popup.vue'

Vue.config.productionTip = false
Vue.use(global)
Vue.component('Throttle', Throttle)
Vue.component('Tab', Tab)
Vue.component('Popup', Popup)

new Vue({
  render: h => h(App)
}).$mount('#app')
